import { CenteredSpinner, MainLayout } from '@common/components';
import { Outlet } from 'react-router-dom';
import { getToken } from '@wisory-international-ab/login-frontend';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '@/hooks';
import ApplicationProvider from '@/context/application-settings';
import { isStandaloneWebApp } from '@/common/utils/pwa';

export function RequireAuth() {
  const { t } = useTranslation();
  const { goToLoginPage, getProfile, user } = useAuth();

  useEffect(() => {
    const userSession = getToken();

    if (!userSession) {
      goToLoginPage();
    } else if (userSession && !user) {
      getProfile()
        .then(() => {
          if (isStandaloneWebApp()) {
            document.body.style.backgroundColor = '#095134';
          }
        })
        .catch(() => {
          goToLoginPage();
        });

      return;
    }
  }, [getProfile, goToLoginPage, user]);

  if (!user) {
    return (
      <div style={{ background: '#fff', height: '100vh' }}>
        <CenteredSpinner message={t('share.navigating')} />
      </div>
    );
  }

  return (
    <ApplicationProvider>
      <MainLayout>
        <Outlet />
      </MainLayout>
    </ApplicationProvider>
  );
}
